import classNames from "classnames";
import { FC, ReactNode } from "react";

import { ReactComponent as CourseUpIcon } from "assets/images/common/course-up.svg";
import { ReactComponent as DangerIcon } from "assets/images/common/danger.svg";
import { ReactComponent as GrowDownIcon } from "assets/images/common/grow-down.svg";
import { ReactComponent as GrowUpIcon } from "assets/images/common/grow-up.svg";
import { ReactComponent as InfoIcon } from "assets/images/common/info.svg";
import { ReactComponent as LongArrowIcon } from "assets/images/common/long-arrow.svg";
import { ReactComponent as ShieldIcon } from "assets/images/common/shield.svg";

import styles from "./style.module.scss";

export type StatTone = "green" | "red" | "orange" | "gray";

export type StatIcon = "shield" | "course-up" | "danger" | "grow-up" | "grow-down" | "flat";

export type StatCardData = {
  title: string;
  value: string | number;
  description: string;
  icon?: StatIcon;
  tone: StatTone;
  tooltip?: string;
};

const STAT_ICONS: Record<StatIcon, ReactNode> = {
  shield: <ShieldIcon />,
  "course-up": <CourseUpIcon />,
  danger: <DangerIcon />,
  "grow-up": <GrowUpIcon />,
  "grow-down": <GrowDownIcon />,
  flat: <LongArrowIcon />,
};

type PropTypes = {
  data: StatCardData;
  className?: string;
};

const StatCard: FC<PropTypes> = ({ data, className }) => {
  return (
    <div className={classNames(styles.card, styles[`bar-${data.tone}`], className)}>
      <div className={styles.head}>
        <span className={styles.title}>{data.title}</span>
        {data.icon && <span className={classNames(styles.icon, styles[data.tone])}>{STAT_ICONS[data.icon]}</span>}
      </div>

      <div className={styles.body}>
        <div className={styles.valueRow}>
          <span className={styles.value}>{data.value}</span>

          {data.tooltip && (
            <span className={styles.info} tabIndex={0}>
              <InfoIcon />
              <span className={styles.tooltip}>{data.tooltip}</span>
            </span>
          )}
        </div>

        <span className={styles.description}>{data.description}</span>
      </div>
    </div>
  );
};

export default StatCard;
